// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/scim/scim.actions.go

export const DELETE_GROUP = "mondoo.scim.UserProvisioning.DeleteGroup";
